import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';

export function BottomActionBar({
  cancelText,
  onCancel,
  actionText,
  onAction,
  showActionButton,
  confirmLoading,
}) {
  return (
    <>
      <Row className="bottom-action-bar">
        <Button size="large" onClick={onCancel}>
          {cancelText}
        </Button>
        {showActionButton && (
          <Button
            type="primary"
            size="large"
            onClick={onAction}
            loading={confirmLoading}
          >
            {actionText}
          </Button>
        )}
      </Row>
      <style jsx global>{`
        .bottom-action-bar {
          width: 100%;
          gap: 8px;
          padding: 8px 16px;
          margin-top: 8px;
          display: flex;
          background-color: ${Colors.white};
          justify-content: flex-end;
        }
      `}</style>
    </>
  );
}

BottomActionBar.propTypes = {
  cancelText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  actionText: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  showActionButton: PropTypes.bool,
  confirmLoading: PropTypes.bool,
};
